import React from 'react';

function ProgressBar({ currentStep, totalSteps }) {
  const percent = Math.round((currentStep / totalSteps) * 100);
  return (
    <div className="survey-progress" role="progressbar" aria-valuenow={currentStep} aria-valuemin={1} aria-valuemax={totalSteps}>
      <div className="survey-progress-track">
        <div className="survey-progress-fill" style={{ width: `${percent}%` }} />
      </div>
      <span className="survey-progress-label">Step {currentStep} of {totalSteps}</span>
    </div>
  );
}

export default ProgressBar;
